// extracted by mini-css-extract-plugin
export default {"transactions":"dashboard_transactions__8WSy8"};